import CryptoJS from 'crypto-js';
const crypto_key = 'cometwxffe3e88b0b8dc8cbjuyuan';

const md5 = (text) => {
    return  CryptoJS.MD5(CryptoJS.MD5(text+crypto_key).toString()).toString();
}

export default md5;